import * as commonScripts from '../common'
import 'whatwg-fetch'

const cmpSearch = {
  component: null,
  apiEndpoint: null,
  form: null,
  formInput: null,
  origQuery: null,
  resultsDiv: null,
  docresultsDiv: null,
  loadingMsg: null,
  loadMoreBtn: null,
  docloadMoreBtn: null,
  searchTabs: null,
  query: {},

  init: function (element) {
    const _ = this
    _.component = element
    _.apiEndpoint = (window.location.hostname !== 'localhost') ? '/api/search' : 'https://barings-develop.herodigital.dev/api/search'
    _.form = _.component.querySelector('form')
    _.formInput = _.component.querySelector('.input-search')
    _.origQuery = _.component.querySelector('.original-query').value
    _.resultsDiv = _.component.querySelector('.find-index-results .cmp-search__results')
    _.docresultsDiv = _.component.querySelector('.doc-results .cmp-doc__results')
    _.loadingMsg = _.component.querySelector('.cmp-search__loading')
    _.loadMoreBtn = _.component.querySelector('.find-index-results .btn-load-more')
    _.docloadMoreBtn = _.component.querySelector('.doc-results .btn-load-more')
    _.searchTabs = _.component.querySelectorAll('.cmp-tabs__nav button')

    const formInputPlaceholder = _.formInput.getAttribute('placeholder')
    const clearBtn = _.component.querySelector('.clear-search')

    _.formInput.addEventListener('focus', (e) => {
      e.preventDefault()
      _.formInput.setAttribute('placeholder', '')
    })

    _.formInput.addEventListener('blur', (e) => {
      e.preventDefault()
      _.formInput.setAttribute('placeholder', formInputPlaceholder)
    })

    clearBtn.addEventListener('click', (e) => {
      e.preventDefault()
      _.formInput.value = null
    })

    _.loadMoreBtn.addEventListener('click', (e) => {
      e.preventDefault()
      const query = _.formInput.value
      if (query) {
        if (query !== _.origQuery) {
          _.form.submit()
        } else {
          _.loadingMsg.classList.remove('d-none')
          _.loadMoreBtn.classList.add('disabled')
          const prevPage = _.loadMoreBtn.getAttribute('data-page') * 1
          _.loadMoreBtn.setAttribute('data-page', prevPage + 1)
          _.buildQuery();
        }
      }
    })
    if (_.docloadMoreBtn != null) {
      _.docloadMoreBtn.addEventListener('click', (e) => {
        e.preventDefault()
        const query = _.formInput.value
        if (query) {
          if (query !== _.origQuery) {
            _.form.submit()
          } else {
            _.loadingMsg.classList.remove('d-none')
            _.docloadMoreBtn.classList.add('disabled')
            const prevPage = _.docloadMoreBtn.getAttribute('data-page') * 1
            _.docloadMoreBtn.setAttribute('data-page', prevPage + 1)
            _.buildQuery();
          }
        }
      })
    }

    _.searchTabs.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        if (e.target.id == 'tab-2') {
          _.component.querySelector('.websiteresults').setAttribute('hidden', '')
          _.component.querySelector('.docresults ').removeAttribute('hidden', '')
          _.component.querySelector('.find-index-results .btn-load-more').classList.remove('active')
          _.component.querySelector('.doc-results .btn-load-more').classList.add('active')
        }
        else {
          _.component.querySelector('.docresults ').setAttribute('hidden', '')
          _.component.querySelector('.websiteresults').removeAttribute('hidden', '')
          _.component.querySelector('.find-index-results .btn-load-more').classList.add('active')
          _.component.querySelector('.doc-results .btn-load-more').classList.remove('active')
        }
      })
    })
  },

  buildQuery: function () {
    const _ = this
    const page = _.component.querySelector('.btn-load-more.active').getAttribute('data-page')
    const pageSize = 8
    _.fetchResults(page, pageSize)
  },

  fetchResults: function (page, pageSize) {
    const _ = this
    let data = jsArray;
    let start = (page - 1) * pageSize
    let activeTab = _.component.querySelector('.cmp-tabs__nav button.active')
    if (activeTab != null && activeTab.id == 'tab-2') {
      let subData = data.docHits.slice(start, start + 8)
      let pageCount = Math.ceil(data.docTotalResults / data.docPageSize);
      _.processResponse(subData, page, pageCount, activeTab)
    }
    else {
      let subData = data.hits.slice(start, start + 8)
      let pageCount = Math.ceil(data.totalResults / pageSize);
      _.processResponse(subData, page, pageCount, activeTab)
    }
  },

  processResponse: function (data, page, pageCount, activeTab) {
    const _ = this

    if (data.length) {
      const stagingDiv = document.createElement('div')
      stagingDiv.classList.add('staging-zone')
      let html = ''
      if (activeTab != null && activeTab.id == 'tab-2') {
        data.forEach(element => {
          html += _.doctemplate(element)
        })
        stagingDiv.insertAdjacentHTML('beforeend', html)
        commonScripts.util.inheritPermalink(stagingDiv)
        _.docresultsDiv.appendChild(stagingDiv)
        _.showHideMoreBtn(page, pageCount)
        _.loadingMsg.classList.add('d-none')
        _.docloadMoreBtn.classList.remove('disabled')
        _.loadMoreBtn.blur()
      }
      else {
        data.forEach(element => {
          html += _.template(element)
        })
        stagingDiv.insertAdjacentHTML('beforeend', html)
        commonScripts.util.inheritPermalink(stagingDiv)
        _.resultsDiv.appendChild(stagingDiv)
        _.showHideMoreBtn(page, pageCount)
        _.loadingMsg.classList.add('d-none')
        _.loadMoreBtn.classList.remove('disabled')
        _.loadMoreBtn.blur()
      }
    }
  },

  showHideMoreBtn: function (page, pageCount) {
    const _ = this
    if (page < pageCount) {
      _.component.querySelector('.btn-load-more.active').classList.remove('d-none')
    } else {
      _.component.querySelector('.btn-load-more.active').classList.add('d-none')
    }
  },

  template: function (data) {
    const metaData = data.subsection ? '<div class="cmp-search__item__meta">' + data.subsection + '</div>' : ''
    const html = `
    <div class="cmp-search__item inherit-permalink">
      <h4 class="cmp-search__item__title">
          <a href="${data.url}" class="permalink">${data.title}</a>
      </h4>
      ${metaData}
      <div class="cmp-search__item__excerpt">${data.excerpt}</div>
    </div>
    `
    return html
  },

  doctemplate: function (data) {
    const metaData = data.documentUrl ? '<div class="cmp-search__item__meta">' + data.documentUrl + '</div>' : ''
    const html = `
    <div class="cmp-search__item inherit-permalink">
      <h4 class="cmp-search__item__title">
          <a href="${data.documentUrl}" class="permalink">${data.documentName}</a>
      </h4>
      ${metaData}
    </div>
    `
    return html
  }
}

export default cmpSearch
